import {
  Button,
  DatePicker,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Table,
  Select,
  Checkbox,
  Tooltip,
} from "antd";
import "leaflet-arrowheads";
import dayjs from "dayjs";
import React, { Component } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";

import "@elfalem/leaflet-curve";
import { Icon } from "leaflet";
import { MapContainer, TileLayer } from "react-leaflet";
import config from "../config";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";

import { addMinutes, format } from "date-fns";
import Draggable from "react-draggable";

import HistoryTrackingStore from "../store/HistoryTrackingStore";
import { observer } from "mobx-react-lite";
import { StoreContext } from "../store/RootStore";

import "leaflet-curve"; // Include the Leaflet-Curve library

import CompanyStore from "../store/CompanyStore";
import AdditionalContentInMap from "./AdditionalContentInMap";
import { PauseCircle, PlayCircle } from "react-bootstrap-icons";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";

// import "leaflet-curve/dist/leaflet.curve.css"; // Include the CSS
const { RangePicker } = DatePicker;
const { Option } = Select;
const cardCss = {
  background: "#ffffff",
  border: "solid 1px #CBCBCB",
  // padding: "15px",
  borderRadius: "5px",
  position: "absolute",
  // left: "28%",
  // top: "2%",
  // width: "25%",
  update: 0,
  isPlaying: true,
  type: "",

  traffic: false,
  flag: true,
  mapBtn: false,
  satelliteBtn: false,
  trafficBtn: false,
};

class HistoryTracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      historyTrackingWindow: true,
      // fromTime: "00:00:00",
      mapType: "google",
      offset: "",
      limit: "",
      loadList: 0,
      speed: 180,
      routeOption: 0,
      // toTime: dayjs().format("HH:mm:ss"),
      showBtn: false,
      updateRouteOption: 0,
      update2: 0,
      // fromDate: "",
      pauseBtnFeature: false,
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      showMapOptions: true,
      tripEventOption: "",

      updateTripOption: false,
      playTripRouteMap: {},
      selectedRows: [],
      currentIndex: 0,
      startTime: "",
      showGrid:
        JSON.parse(base64_decode(Cookies.get("data")))?.industry === "Marine"
          ? false
          : true,
      mapHeight:
        JSON.parse(base64_decode(Cookies.get("data")))?.industry === "Marine"
          ? "100vh"
          : "70vh",

      minimized: false,
      visible: true,
      selectedCompanyId: "",
      selectedRowId: null,
    };
    this.mapRef = React.createRef();
    this.polyline2 = null;
    this.marker2 = [];
    this.companyStore = new CompanyStore(this);

    this.plotPolyLine = [];
    this.polylines = {};
    this.currentPlayingRecord = {};
    this.tripPolyline = null;
    this.circleMarkers = [];
    this.circleMarkersByRecord = {};
    this.mapOptions = [
      {
        label: "Google",
        value: "google",
      },
      {
        label: "Openstreet",
        value: "openstreet",
      },
    ];
    // this.columns = [
    //   {
    //     title: "Location",
    //     dataIndex: "formatted_address",
    //     width: "15%",
    //   },
    //   {
    //     title: "Speed(Km)",
    //     dataIndex: "speed",
    //     width: "15%",
    //   },
    //   {
    //     title: "Ignition",
    //     dataIndex: "ignition",
    //     width: "15%",
    //     render: (val) => {
    //       return "ON";
    //     },
    //   },
    //   {
    //     title: "Date Time",
    //     dataIndex: "updatedate",
    //     width: "15%",
    //   },
    // ];
    this.formRef = React.createRef();
    this.removeMarkerPoints = [];
    this.historyTrackingStore = new HistoryTrackingStore(this);
  }

  handleMinimize = () => {
    this.setState((prev) => ({ minimized: !prev.minimized }));
  };

  handleClose = () => {
    this.setState({ visible: false });
  };
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 ||
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });

      await this.historyTrackingStore.getVehicles({
        companyId: this.props.getUserData().userCompanyId,
      });
      //console.log(JSON.parse(base64_decode(Cookies.get("data"))).industry);
      // if(JSON.parse(base64_decode(Cookies.get("data")))?.industry === 'Marine'){
      //     this.setState({showGrid:false})
      //     this.setState({ mapHeight: "100vh" }, () => {
      //               if (this.mapRef.current) {
      //                 this.mapRef.current.invalidateSize();
      //               }
      //     });
      // }
    }

    this.columns = [
      {
        // title: "Location",
        title: this.context.translate(
          "_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"
        ),
        dataIndex: "formatted_address",
        width: "60%",
      },
      {
        // title: "Speed(Km)",
        title: this.context.translate("_SPEED_KM_"),
        dataIndex: "speed",
        width: "15%",
      },
      {
        // title: "Ignition",
        title: this.context.translate("_IGNITION_"),
        dataIndex: "ignition",
        width: "15%",
        render: (val, record) => {
          if (Number(record.acc) === 1) {
            return <>ON</>;
          } else {
            return <>OFF</>;
          }
        },
      },
      {
        // title: "Date Time",
        title: this.context.translate("_DATE_TIME_"),
        dataIndex: "updatedate",
        render: (value) => {
          const formattedDateTime = dayjs(value).format(
            "DD-MM-YYYY hh:mm:ss A"
          );
          return <>{formattedDateTime}</>;
        },
        width: "10%",
      },
    ];

    this.tripColumns = [
      {
        title: this.context.translate(
          "_FLEET_RULEDETAIL_PREDEFINEACTIONDDL_SELECT_"
        ),
        dataIndex: "select",
        align: "center",
        render: (_, record) => {
          // console.log(record);
          return (
            <Checkbox
              checked={this.state.selectedRows.includes(record.startTime)}
              onChange={(e) => {
                this.handleCheckboxChange(e, record.startTime, record);
                this.setState({ startTime: record.startTime });
              }}
            />
          );
        },
      },

      {
        title: this.context.translate("_PLAY_"),
        dataIndex: "play",
        align: "center",
        render: (val, record, index) => {
          const isPlaying = this.state.playTripRouteMap[record.startTime];
          const isDifferentRecord =
            this.currentPlayingRecord &&
            this.currentPlayingRecord.startTime !== record.startTime;

          // if (this.state.routeOption === 4) {
          return (
            <div style={{ display: "inline-flex", alignItems: "center" }}>
              {!isPlaying ? (
                <Tooltip title="Play" color="green">
                  {" "}
                  <PlayCircle
                    style={{ fontSize: "24px", cursor: "pointer" }}
                    onClick={() => {
                      this.handlePlay(record, isDifferentRecord);
                      this.setState({ startTime: record.startTime });
                    }}
                  ></PlayCircle>
                </Tooltip>
              ) : (
                <>
                  <Tooltip title="Pause" color="green">
                    {" "}
                    <PauseCircle
                      style={{ fontSize: "24px" }}
                      onClick={() => this.handlePause(record)}
                    ></PauseCircle>
                  </Tooltip>

                  <Tooltip title="Clear" color="green">
                    {" "}
                    <i
                      class="bi bi-x"
                      onClick={() => this.handleStop(record, record.startTime)}
                      style={{ fontSize: "24px" }}
                    ></i>
                  </Tooltip>
                </>
              )}
            </div>
          );
          // }
          // return null;
        },
      },

      {
        title: this.context.translate("_ASSET_NAME_"),
        dataIndex: "vehicleNo",
        render: (val) => {
          const doc = new DOMParser().parseFromString(val, "text/html");
          const strongElement = doc.querySelector("strong");
          return strongElement ? strongElement.textContent || "" : val;
        },
      },
      {
        title: this.context.translate(
          "_FLEET_REPORTS_STARTSTOPREPORT_STARTDATETIME_"
        ),
        dataIndex: "startTime",
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        title: this.context.translate(
          "_FLEET_REPORTS_STARTSTOPREPORT_STARTADDRESS_"
        ),
        dataIndex: "startLocation",
      },
      {
        title: this.context.translate(
          "_FLEET_REPORTS_STARTSTOPREPORT_STOPDATETIME_"
        ),
        dataIndex: "stopTime",
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        title: this.context.translate(
          "_FLEET_REPORTS_STARTSTOPREPORT_STOPADDRESS_"
        ),
        dataIndex: "stopLocation",
      },
      {
        title: this.context.translate("_DISTANCE_TRAVELED_"),
        dataIndex: "distanceTravelled",
        render: (val) => {
          const doc = new DOMParser().parseFromString(val, "text/html");
          const strongElement = doc.querySelector("strong");
          return strongElement ? strongElement.textContent || "" : val;
        },
      },
      {
        title: this.context.translate(
          "_FLEET_REPORTS_STARTSTOPREPORT_ELAPSEDTIME_"
        ),
        dataIndex: "elapsedTime",
        render: (val) => {
          const doc = new DOMParser().parseFromString(val, "text/html");
          const strongElement = doc.querySelector("strong");
          return strongElement ? strongElement.textContent || "" : val;
        },
      },
    ];
    if (this.props.vehicleInfoObj) {
      const obj = this.props.vehicleInfoObj;

      console.log(obj.companyId, "obj.companyId");
      this.setState({ selectedCompanyId: obj.companyId });
      const getCompanyData = await this.companyStore.getSingleCompanyData(
        obj.companyId
      );

      await this.setState({ companyId: getCompanyData.companyId });
      await this.historyTrackingStore.getVehicles({
        companyId: getCompanyData.companyId,
      });
      await this.formRef.current.setFieldsValue({
        companyId: [
          { value: getCompanyData.companyId, label: getCompanyData.name },
        ],
        vehicleId: obj.vehicleId,
      });
    }
    this.setState({ update: 1 });
  }
  async componentDidUpdate(prevProps, prevState) {
    const isMarine =
      JSON.parse(base64_decode(Cookies.get("data")))?.industry === "Marine";

    // if (isMarine) {
    //   const { vehiclesArray } = this.historyTrackingStore;

    //   if (
    //     vehiclesArray &&
    //     vehiclesArray.length > 0 &&
    //     vehiclesArray !== prevProps.historyTrackingStore?.vehiclesArray
    //   ) {
    //     const defaultVehicle = vehiclesArray[0];
    //     this.formRef.current?.setFieldsValue({
    //       vehicleId: defaultVehicle.vehicleId,
    //     });
    //   }
    // }
  }

  handleCheckboxChange = async (e, key, record) => {
    const { checked } = e.target;
    this.setState((prevState) => {
      const { selectedRows } = prevState;

      return {
        selectedRows: checked
          ? [...selectedRows, key]
          : selectedRows.filter((rowKey) => rowKey !== key),
      };
    });
    const tripDataObj = {
      companyId: record.companyId,
      vehicleId: record.vehicleId,
      fromDate: record.startTime,
      toDate: record.stopTime,
      SelRoutOption: 4,
      TripEventdata: 1,
    };

    if (checked) {
      const data = await this.historyTrackingStore.getHistTracDataForTrip(
        tripDataObj
      );
      await this.showTripPolyline(key, data);
    }

    if (!checked) {
      await this.clearTripPolyline(key);
      if (this.circleMarkersByRecord[key]) {
        this.circleMarkersByRecord[key].forEach((circle) => {
          circle.remove();
        });
        delete this.circleMarkersByRecord[key]; // Clear markers for this key
      }
    }
  };

  showTripPolyline = async (key, data) => {
    this.plotPolyLine = data.map((val) => [val.latitude, val.longitude]);

    const polyline = L.polyline(this.plotPolyLine, {
      color: "green",
      smoothFactor: 5,
      weight: 4,
      id: key,
    }).addTo(this.mapRef.current);

    this.polylines[key] = polyline;

    const bounds = polyline.getBounds();
    this.mapRef.current.fitBounds(bounds, { minZoom: 10 });

    polyline.arrowheads({
      size: "6px",
      color: "blue",
    });
    data.forEach((val) => {
      let circleColor;
      if (val.activity == "Travel") {
        circleColor = "green";
      } else if (val.activity == "Idle") {
        circleColor = "orange";
      } else if (val.activity == "Stop") {
        circleColor = "red";
      }

      // Add a circle
      const circle = L.circleMarker([val.latitude, val.longitude], {
        color: circleColor, // color of the circle's border
        fillColor: circleColor, // fill color of the circle
        fillOpacity: 1, // opacity of the fill color
        radius: 3,
      }).addTo(this.mapRef.current);
      if (!this.circleMarkersByRecord[key]) {
        this.circleMarkersByRecord[key] = [];
      }
      this.circleMarkersByRecord[key].push(circle);
    });
  };

  clearTripPolyline = (key) => {
    // Check if polyline exists for this key and remove it
    if (this.polylines[key]) {
      this.mapRef.current.removeLayer(this.polylines[key]);
      delete this.polylines[key]; // Remove reference from `polylines` object
    }
  };

  handlePlay = async (record, isDifferentRecord) => {
    if (
      this.currentPlayingRecord &&
      this.currentPlayingRecord.startTime !== record.startTime
    ) {
      this.handleStop(this.currentPlayingRecord);
      this.historyTrackingStore.offTripDataArr = [];
      this.historyTrackingStore.currentIndex = 0;
      this.historyTrackingStore.pgcount = 1;
      this.historyTrackingStore.offset = 0;
      this.historyTrackingStore.totalCount = null;
      this.historyTrackingStore.offlineDataNewObj = [];
      // this.state.playTripRouteMap = {};
      this.setState({ playTripRouteMap: {} });
    }

    const data = {
      companyId: record.companyId,
      vehicleId: record.vehicleId,
      fromDate: record.startTime,
      toDate: record.stopTime,
      SelRoutOption: "1",
      TripEventdata: 1,
      tableName: "mt90",
    };

    await this.historyTrackingStore.setOfflineData(data);

    this.setState((prevState) => ({
      updateTripOption: false, // Set to false to resume plotting
      playTripRouteMap: {
        ...prevState.playTripRouteMap,
        [record.startTime]: true,
      },
    }));

    this.currentPlayingRecord = record;

    await this.logValuesWithDelay(record.startTime);
  };

  handlePause = async (record) => {
    await this.setState((prevState) => ({
      updateTripOption: true,
      playTripRouteMap: {
        ...prevState.playTripRouteMap,
        [record.startTime]: false,
      },
    }));
  };

  handleStop = async (record, key) => {
    // console.log(key, "key");
    await this.setState((prevState) => {
      const updatedMap = { ...prevState.playTripRouteMap };
      delete updatedMap[record.startTime];
      return { playTripRouteMap: updatedMap, updateTripOption: true };
    });
    this.historyTrackingStore.offTripDataArr = [];
    this.historyTrackingStore.currentIndex = 0;
    // Remove the polyline from the map
    if (this.tripPolyline) {
      this.mapRef.current.removeLayer(this.tripPolyline);
      this.tripPolyline = null;
    }

    if (this.circleMarkersByRecord) {
      Object.keys(this.circleMarkersByRecord).forEach((startKey) => {
        this.circleMarkersByRecord[startKey].forEach((circle) => {
          circle.remove(); // Remove each circle marker from the map
        });
        delete this.circleMarkersByRecord[startKey]; // Clear markers for this startKey
      });
      // console.log(
      //   "All circle markers have been cleared:",
      //   this.circleMarkersByRecord
      // );
    }
  };

  logValuesWithDelay = async (startTime) => {
    // console.log(startTime, "startTime");

    if (
      this.historyTrackingStore.currentIndex >=
      this.historyTrackingStore.offlineDataNewObj.length
    ) {
      // console.log("End of records reached.");
      return "done";
    }
    let latlongs = await this.historyTrackingStore.offlineDataNewObj[
      this.historyTrackingStore.currentIndex
    ];
    // console.log(latlongs, "latlongs");

    if (latlongs) {
      // let polyLineArray = await this.historyTrackingStore?.offTripDataArr;
      await this.historyTrackingStore.offTripDataArr?.push([
        latlongs.latitude,
        latlongs.longitude,
      ]);
    }
    let timeout = setTimeout(async () => {
      if (this.state.updateTripOption) {
        return;
      }

      if (latlongs?.latitude != null && latlongs?.longitude != null) {
        if (this.tripPolyline) {
          this.mapRef.current.removeLayer(this.tripPolyline);
        }

        this.tripPolyline = L.polyline(
          this.historyTrackingStore.offTripDataArr,
          { color: "blue", weight: 3 }
        )
          .arrowheads({
            size: "6px",
            color: "blue", // Set arrow color to blue
          })

          .addTo(this.mapRef.current);
        // if (latlongs) {
        //   this.tripPolyline.bindTooltip(
        //     `<div style='background:white;text-align:left;padding:5px;max-width:250px;word-wrap:break-word;'>
        //         <b>Date Time:</b> ${latlongs?.updatedate || "N/A"} <br/>
        //         <b>Speed:</b> ${latlongs?.speed || "N/A"} <br/>
        //         <b>Location:</b>
        //         ${
        //           latlongs?.formatted_address
        //             ? latlongs.formatted_address.replace(/(.{30})/g, "$1<br/>")
        //             : "N/A"
        //         }
        //       </div>`,
        //     {
        //       // permanent: true,
        //       direction: "top",
        //       offset: [0, -10],
        //     }
        //   );
        // }

        const totalLength = this.historyTrackingStore.offlineDataNewObj.length;
        const currentIndex = this.historyTrackingStore.currentIndex;
        console.log(totalLength, "totalLength");
        console.log(totalLength - 1, currentIndex === totalLength - 1);
        let pointLabel = "";
        if (currentIndex === 0) {
          pointLabel = "<b>Start Point</b><br/>";
        } else if (currentIndex === totalLength - 1) {
          pointLabel = "<b style='color:red'>End Point</b><br/>";
        }
        let circleColor;
        if (latlongs.activity == "Travel") {
          circleColor = "green";
        } else if (latlongs.activity == "Idle") {
          circleColor = "orange";
        } else if (latlongs.activity == "Stop") {
          circleColor = "red";
        }

        // Add a circle
        const circle = L.circleMarker([latlongs.latitude, latlongs.longitude], {
          color: circleColor, // color of the circle's border
          fillColor: circleColor, // fill color of the circle
          fillOpacity: 1, // opacity of the fill color
          radius: 3,
        })
          .addTo(this.mapRef.current)
          .bindTooltip(
            `<div  class="custom-tooltip">
                ${pointLabel}
                <b>Vehicle No:</b> ${latlongs?.vehicleNo || "N/A"} <br/>
                <b>Date Time:</b> ${latlongs?.updatedate || "N/A"} <br/>
                <b>Speed:</b> ${latlongs?.speed || "N/A"} <br/>
                <b>Location:</b>
                ${
                  latlongs?.formatted_address
                    ? latlongs.formatted_address.replace(/(.{30})/g, "$1<br/>")
                    : "N/A"
                }
              </div>`,
            {
              // permanent: true,
              direction: "top",
              offset: [0, -10],
              className: "no-white-tooltip",
            }
          );

        if (!this.circleMarkersByRecord[startTime]) {
          this.circleMarkersByRecord[startTime] = [];
        }
        this.circleMarkersByRecord[startTime].push(circle);

        this.mapRef.current?.setView(
          [latlongs?.latitude, latlongs?.longitude],
          16
        );
      }
      this.historyTrackingStore.currentIndex += 1;
      // console.log(this.historyTrackingStore.currentIndex, "**");
      clearTimeout(timeout);
      await this.logValuesWithDelay();
    }, 1000);
  };

  timeOptions = () => {
    const timeArray = [];
    let startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM
    let endTime = new Date(2000, 0, 1, 23, 30);
    for (let time = startTime; time <= endTime; time = addMinutes(time, 30)) {
      // const formattedTime = format(time, 'h:mm aa');
      const formattedTime = format(time, "HH:mm:ss");
      var ob = {
        formattedTime: formattedTime,
        time: time,
      };
      timeArray.push(ob);
    }
    // console.log(timeArray);
    return timeArray.map((data) => {
      return (
        <Select.Option key={data.formattedTime} value={data.formattedTime}>
          {format(data.time, "h:mm aa")}
        </Select.Option>
      );
    });
  };

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    }
  };

  // Modal Function for polt the polyline with timer
  drawPolylineUsingTimerFunc = async ({
    vehicleObj,
    polyLineArray,
    callBackFunc,
  }) => {
    let speed = this.state.speed;
    if (this.state.speed === 1) {
      speed = 125;
    } else if (this.state.speed === 2) {
      speed = 400;
    } else if (this.state.speed === 3) {
      speed = 750;
    }

    if (this.state.isPlaying === false) {
      return;
    }
    setTimeout(() => {
      if (this.state.updateRouteOption === 0) {
        this.clearMap();
        return;
      }
      let speed = Number(vehicleObj?.speed);
      let speedLimit = Number(vehicleObj?.speedLimit);
      let toolTipDta;
      let activity;
      if (this.state.routeOption !== 5) {
        const polyline = L.polyline(
          polyLineArray,
          {
            color: "blue",
          },
          20
        ).addTo(
          this.props.mapRef ? this.props.mapRef.current : this.mapRef.current
        );
      }

      if (
        this.state.routeOption === 1 ||
        this.state.routeOption === 3 ||
        this.state.routeOption === 4
      ) {
        if (this.state.tripEventOption > 1) {
          console.log(this.state.tripEventOption, "this.state.tripEventOption");

          let obj = { 1: "All", 2: "Green", 3: "Red", 4: "Orange" };
          activity = obj[this.state.tripEventOption];
          toolTipDta = 2;
        } else {
          if (
            vehicleObj.activity === "Travel" ||
            (Number(vehicleObj.acc) === 1 && Number(vehicleObj.speed) > 0)
          ) {
            activity = "Green";
            toolTipDta = 1;
          } else if (
            vehicleObj.activity === "Idle" ||
            (Number(vehicleObj.acc === 1) && Number(vehicleObj.speed) === 0)
          ) {
            activity = "Orange";
            toolTipDta = 2;
          } else if (
            vehicleObj.activity === "Stop" ||
            Number(vehicleObj.acc) === 0
          ) {
            activity = "Red";
            toolTipDta = 2;
          }
        }

        if (activity) {
          let rotationAngle = Number(vehicleObj.direction);
          var direction;

          if (rotationAngle >= 0 && rotationAngle < 22.5) {
            direction = "north";
          } else if (rotationAngle >= 22.5 && rotationAngle < 67.5) {
            direction = "north-east";
          } else if (rotationAngle >= 67.5 && rotationAngle < 112.5) {
            direction = "east";
          } else if (rotationAngle >= 112.5 && rotationAngle < 157.5) {
            direction = "south-east";
          } else if (rotationAngle >= 157.5 && rotationAngle < 202.5) {
            direction = "south";
          } else if (rotationAngle >= 202.5 && rotationAngle < 247.5) {
            direction = "south-west";
          } else if (rotationAngle >= 247.5 && rotationAngle < 292.5) {
            direction = "west";
          } else if (rotationAngle >= 292.5 && rotationAngle < 337.5) {
            direction = "north-west";
          } else if (rotationAngle >= 337.5 && rotationAngle < 360) {
            direction = "north";
          } else {
            direction = "north-east";
          }

          const activityImage = require(`../assets/images/BaloonIcons/${activity}-${direction}.png`);

          this.marker2 = L.marker([vehicleObj.latitude, vehicleObj.longitude], {
            icon: L.divIcon({
              className: "custom-marker",
              iconSize: [25, 25],
              html: `
              <img src=${activityImage} alt="Icon" style=  "width: 100%; height: 100%;">`,
            }),
          })
            .bindTooltip(
              // "<div style='background:#00ff00;border:solid 1px #000;text-align:center;padding:0'><b>Sammek</b></div>",
              toolTipDta === 2 && vehicleObj.activity
                ? `<div style='background:#00ff00;border:solid 1px #000;text-align:left;padding:10px;'>
      <b>${this.context.translate("_VEHICLE_NO_")}:</b> ${
                    vehicleObj.vehicleNo
                  } <br/>
      <b>${vehicleObj.activity} From:</b> ${
                    vehicleObj.fromdate ? vehicleObj.fromdate : ""
                  } <br/>
      <b>${vehicleObj.activity} To:</b> ${
                    vehicleObj.todate ? vehicleObj.todate : ""
                  } <br/>
                  <b>Location:</b> ${
                    vehicleObj.formatted_address
                      ? vehicleObj.formatted_address
                      : ""
                  } <br/>
      <b>Duration:</b> ${
        vehicleObj.elapsedTime ? vehicleObj.elapsedTime : ""
      }  <br/>
      <b>Weight:</b> ${
        vehicleObj.emptyWeight ? vehicleObj.emptyWeight : ""
      } <br/>
    </div>`
                : `<div style='background:#00ff00;border:solid 1px #000;text-align:left;padding:10px; width:200;'>
    <b>${this.context.translate("_VEHICLE_NO_")}:</b> ${
                    vehicleObj.vehicleNo
                  } <br/>
    <b>Date Time:</b> ${vehicleObj?.updatedate} <br/>
    <b>Location:</b> ${vehicleObj?.formatted_address} <br/>
    <b>Speed:</b> ${vehicleObj.speed ? vehicleObj.speed : ""} <br/>
    <b>Weight:</b> ${vehicleObj.emptyWeight ? vehicleObj.emptyWeight : ""} <br/>
  </div>`,

              {
                maxWidth: 300,
                direction: "top",
                // className: "my-labels"
              }
            )

            .addTo(
              this.props.mapRef
                ? this.props.mapRef.current
                : this.mapRef.current
            );
          this.removeMarkerPoints.push([
            Number(vehicleObj.latitude),
            Number(vehicleObj.longitude),
          ]);
        }
      }

      if (polyLineArray.length > 2) {
        const bounds = [
          [
            polyLineArray[polyLineArray.length - 1][0],
            polyLineArray[polyLineArray.length - 1][1],
          ],
          [polyLineArray[0][0], polyLineArray[1][1]],
        ];
        if (this.props.mapRef) {
          this.props.mapRef.current.fitBounds(bounds, { maxZoom: 15 });
        } else {
          this.mapRef.current.fitBounds(bounds, { maxZoom: 15 });
        }
      }

      this.historyTrackingStore.count++;
      if (typeof callBackFunc === "function") {
        callBackFunc();
      }
    }, speed);
  };

  plotMarkersOnPolyline = (data) => {
    if (!data || data.length === 0) return;

    const mapRef = this.props.mapRef
      ? this.props.mapRef.current
      : this.mapRef.current;

    const polyLineArray = data.map((item) => [
      Number(item.latitude),
      Number(item.longitude),
    ]);

    // L.polyline(polyLineArray, { color: "blue", weight: 3 }).addTo(mapRef);

    // Plot each marker on the map
    data.forEach((vehicleObj) => {
      const { latitude, longitude, direction, activity, acc, speed } =
        vehicleObj;

      let rotationAngle = Number(direction);

      let directionName = "north";
      if (rotationAngle >= 0 && rotationAngle < 22.5) {
        directionName = "north";
      } else if (rotationAngle >= 22.5 && rotationAngle < 67.5) {
        directionName = "north-east";
      } else if (rotationAngle >= 67.5 && rotationAngle < 112.5) {
        directionName = "east";
      } else if (rotationAngle >= 112.5 && rotationAngle < 157.5) {
        directionName = "south-east";
      } else if (rotationAngle >= 157.5 && rotationAngle < 202.5) {
        directionName = "south";
      } else if (rotationAngle >= 202.5 && rotationAngle < 247.5) {
        directionName = "south-west";
      } else if (rotationAngle >= 247.5 && rotationAngle < 292.5) {
        directionName = "west";
      } else if (rotationAngle >= 292.5 && rotationAngle < 337.5) {
        directionName = "north-west";
      } else if (rotationAngle >= 337.5 && rotationAngle < 360) {
        directionName = "north";
      } else {
        directionName = "north-east";
      }

      let markerColor;
      let accData = Number(acc);
      let speedData = Number(speed);

      if (activity === "Travel" || (accData === 1 && speedData > 0)) {
        markerColor = "Green";
      } else if (activity === "Idle" || (accData === 1 && speedData === 0)) {
        markerColor = "Orange";
      } else if (accData === "Stop" || speedData === 0) {
        markerColor = "Red";
      }

      const activityImage = require(`../assets/images/BaloonIcons/${markerColor}-${directionName}.png`);

      // Create custom marker
      const marker = L.marker([latitude, longitude], {
        icon: L.divIcon({
          className: "custom-marker",
          iconSize: [25, 25],
          html: `<img src=${activityImage} alt="marker" style="width:100%;height:100%;">`,
        }),
      }).bindTooltip(
        `<div style='background:#00ff00;border:solid 1px #000;text-align:left;padding:10px;'>
        <b>${this.context.translate("_VEHICLE_NO_")}:</b> ${
          vehicleObj.vehicleNo
        }<br/>
        <b>Speed:</b> ${vehicleObj.speed}<br/>
      
        <b>Location:</b> ${vehicleObj.formatted_address || ""}<br/>
      </div>`,
        { maxWidth: 300, direction: "top" }
      );
      // <b>Activity:</b> ${vehicleObj.activity}<br/>
      marker.addTo(mapRef);
      this.removeMarkerPoints.push([latitude, longitude]);
    });

    // Fit map bounds to include all markers
    if (polyLineArray.length > 1) {
      mapRef.fitBounds(polyLineArray, { maxZoom: 15 });
    }
  };

  overSpeedDrawPolyline = async () => {
    if (
      this.historyTrackingStore.count ===
      this.historyTrackingStore.polyLineArray.length
    ) {
      return;
    }
    let vehicleObj =
      this.historyTrackingStore.allArray[this.historyTrackingStore.count];
    let newAry = this.historyTrackingStore.newPolyLineArray.push([
      vehicleObj?.latitude,
      vehicleObj?.longitude,
    ]);

    if (this.state.routeOption === 5) {
      this.historyTrackingStore.allArray?.forEach((val) => {
        if (Number(val.speed) > Number(val.speedLimit)) {
          const marker = L.marker([val.latitude, val.longitude], {
            icon: new Icon({
              iconUrl: require("../assets/images/BaloonIcons/Orange-north-east.png"),
              iconSize: [25, 25], // size of the icon
              rotationAngle: 50,
            }),

            // icon: L.divIcon({
            //   className: 'custom-marker',
            //   iconSize: [25, 25],
            //   html: ` <img src=${require("../assets/images/BaloonIcons/Orange-north-east.png")} alt="Icon" style="transform: rotate(${50}deg) ;  width: 20px; height: 35px;";">`
            // }),
          })
            .bindTooltip(
              // "<div style='background:#00ff00;border:solid 1px #000;text-align:center;padding:0'><b>Sammek</b></div>",
              `<div style='background:#00ff00;border:solid 1px #000;text-align:left;padding:10px;'>
            <b>${this.context.translate("_VEHICLE_NO_")}:</b> ${
                val.vehicleNo
              } <br/>
            <b>Speed:</b> ${val.speed} <br/>
           
            <b>Date Time:</b> ${val.updatedate} <br/>
            <b>Speed Limit:</b> ${val.speedLimit} <br/>
            <b>Weight:</b> ${val.emptyWeight} <br/>
            <!-- Add more fields as needed -->
          </div>`
            )
            .addTo(
              this.props.mapRef
                ? this.props.mapRef.current
                : this.mapRef.current
            );
        }
      });
    } else if (
      this.state.selectedCompanyId == 1903 ||
      (this.state.companyId == 1903 &&
        config.project === "securetrack" &&
        this.state.routeOption === 3)
    ) {
      console.log("first", this.state.selectedCompanyId);
      await this.plotMarkersOnPolyline(
        this.historyTrackingStore.historyTrackingTableData
      );
    } else {
      // Call drawPolylineUsingTimerFunc with a callback
      await this.drawPolylineUsingTimerFunc({
        vehicleObj: vehicleObj,
        polyLineArray: this.historyTrackingStore.newPolyLineArray,
        callBackFunc: this.overSpeedDrawPolyline, // Pass the callback function
      });
    }
  };

  overSpeedAndFullPathFunc = async () => {
    try {
      const polyline = await L.polyline(
        this.historyTrackingStore.polyLineArray.length > 0
          ? this.historyTrackingStore.polyLineArray
          : [],
        {
          color: "green",
          smoothFactor: 5,
        },
        15
      ).addTo(
        this.props.mapRef ? this.props.mapRef.current : this.mapRef.current
      );

      const bounds = polyline.getBounds();

      polyline
        .arrowheads({ size: "6px" })
        .bindPopup
        //   `<pre><code>L.polyline(coords)
        // .arrowheads({
        //   size: '6px',
        //   // frequency: '15px',
        //   // fill: true,
        //   yawn: 20
        // });</code></pre>`
        // { maxWidth: 2000, minWidth: 400 }
        ();

      // Zoom to fit the bounds of the polyline
      if (this.props.mapRef) {
        await this.props.mapRef.current.fitBounds(bounds, { maxZoom: 20 });
      } else {
        await this.mapRef.current.fitBounds(bounds, { maxZoom: 20 });
      }

      await this.overSpeedDrawPolyline();
      // this.setState({ updateRouteOption: 5 });
    } catch (error) {
      console.error("Error:", error);
    }
  };
  straightLineFunc = async () => {
    if (
      this.historyTrackingStore?.offlineDataNewObj?.length > 0 &&
      (this.state.routeOption === 1 || this.state.routeOption === 4)
    ) {
      let vehicleObj =
        this.historyTrackingStore.offlineDataNewObj[
          this.historyTrackingStore.count
        ];
      let newAry = this.historyTrackingStore.newPolyLineArray.push([
        vehicleObj.latitude,
        vehicleObj.longitude,
      ]);
      await this.setState({ update2: 0 });
      // Call drawPolylineUsingTimerFunc with a callback
      await this.drawPolylineUsingTimerFunc({
        vehicleObj: vehicleObj,
        polyLineArray: this.historyTrackingStore.newPolyLineArray,
        callBackFunc: this.straightLineFunc, // Pass the callback function
      });
    }
  };

  // Submit  History Tracking Form
  onFinishHistoryTracking = async (data) => {
    await this.clearMap();

    this.historyTrackingStore.checked = true;
    // console.log(data);
    let infoObj = {
      ...data,
      companyId: this.state.companyId,
      // toDate: dayjs(data.toD).format("YYYY-MM-DD") + " " + this.state.toTime,
      // fromDate:
      //   dayjs(data.fromD).format("YYYY-MM-DD") + " " + this.state.fromTime,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      tableName: "mt90",
      offset: 0,
      limit: 10,
      page: 1,
    };

    const obj = {
      companyId: this.state.companyId,
      vehicleId: data.vehicleId,
      // fromDate:
      //   dayjs(data.fromD).format("YYYY-MM-DD") + " " + this.state.fromTime,
      // toDate: dayjs(data.toD).format("YYYY-MM-DD") + " " + this.state.toTime,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      SelRoutOption: data.SelRoutOption,
      tableName: "mt90",
      TripEventdata: data.TripEventdata,
    };
    // console.log(obj);
    const tripObj = {
      companyId: this.state.companyId,
      vehicleId: data.vehicleId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      interval: 0,
      offset: -1,
      limit: 0,
      page: 0,
    };
    if (data.SelRoutOption === 4) {
      const resp = await this.historyTrackingStore.showTripData(tripObj);

      if (this.historyTrackingStore.tripCount == 0 || resp?.length == 0) {
        Modal.warning({
          content: "Asset Data Not Available...",
          title: "Alert",
        });
      }

      // this.historyTrackingStore.histTrackingClickPolylineObj = [];
      // this.historyTrackingStore.offlineDataNewObj = [];
      // this.historyTrackingStore.offTripDataArr = [];
    }
    if (data.SelRoutOption === 5 || data.SelRoutOption === 3) {
      let response = await this.historyTrackingStore.getHistoryTrackingData(
        obj
      );

      if (response.length > 0) {
        await this.setState({
          showBtn: this.state.routeOption === 5 ? false : true,
          updateRouteOption: 1,
        });
        await this.overSpeedAndFullPathFunc();
      } else {
        Modal.warning({
          content: "Vehicle Data Not Available...",
          title: "Alert",
        });
      }
    }
    // if (data.SelRoutOption === 1 || data.SelRoutOption === 4) {
    if (data.SelRoutOption === 1) {
      await this.historyTrackingStore.setOfflineData(obj);
      if (Number(this.historyTrackingStore.offlineData.totalcount) > 0) {
        await this.setState({
          showBtn: this.state.routeOption === 5 ? false : true,
          updateRouteOption: 1,
        });
        await this.straightLineFunc();
      } else {
        Modal.warning({
          content: "Vehicle Data Not Available...",
          title: "Alert",
        });
      }
    }

    await this.setState({ update2: 1 });
  };

  clearMap = async () => {
    await this.setState({
      updateRouteOption: 0,
      showBtn: false,
      selectedRows: [],
      playTripRouteMap: {},
    });
    this.historyTrackingStore.checked = false;
    if (this.props.mapRef) {
      if (this.props.mapRef.current && this.removeMarkerPoints.length > 0) {
        this.props.mapRef.current.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            const markerLatLng = layer.getLatLng();
            // Check if the marker's coordinates are in the removeMarkerPoints array
            const isMarkerInRemovePoints = this.removeMarkerPoints.some(
              (point) => markerLatLng.equals(L.latLng(point))
            );
            if (isMarkerInRemovePoints) {
              // If the marker's coordinates are in the removeMarkerPoints array, remove it from the map
              this.props.mapRef.current.removeLayer(layer);
            }
          }
        });
      }

      await this.props.mapRef.current.eachLayer((layer) => {
        if (layer instanceof L.Polyline) {
          if (layer.options?.customType === "liveTrackingPolyline") return;
          this.props.mapRef.current.removeLayer(layer);
        }
      });
    } else {
      if (this.props.mapRef?.current && this.removeMarkerPoints?.length > 0) {
        this.props.mapRef.current.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            const markerLatLng = layer.getLatLng();
            // Check if the marker's coordinates are in the removeMarkerPoints array
            const isMarkerInRemovePoints = this.removeMarkerPoints.some(
              (point) => markerLatLng.equals(L.latLng(point))
            );
            if (isMarkerInRemovePoints) {
              // If the marker's coordinates are in the removeMarkerPoints array, remove it from the map
              this.props.mapRef.current.removeLayer(layer);
            }
          }
        });
      }

      await this.mapRef.current.eachLayer((layer) => {
        if (layer instanceof L.Polyline) {
          this.mapRef.current.removeLayer(layer);
        }
      });
    }
    if (this.mapRef) {
      await this.mapRef?.current?.eachLayer((layer) => {
        if (layer instanceof L.Polyline) {
          this.mapRef?.current?.removeLayer(layer);
        }
      });
      await this.mapRef?.current?.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          this.mapRef?.current?.removeLayer(layer);
        }
      });
    }

    // Clear circle markers for all selected `startTime` records
    this.state.selectedRows.forEach((startTime) => {
      if (this.circleMarkersByRecord[startTime]) {
        this.circleMarkersByRecord[startTime].forEach((circle) => {
          circle.remove();
        });
        delete this.circleMarkersByRecord[startTime]; // Clear markers for this key
      }
    });

    if (this.circleMarkersByRecord) {
      console.log("*****");
      Object.keys(this.circleMarkersByRecord).forEach((startKey) => {
        this.circleMarkersByRecord[startKey].forEach((circle) => {
          circle.remove(); // Remove each circle marker from the map
        });
        delete this.circleMarkersByRecord[startKey]; // Clear markers for this startKey
      });
    }

    await this.setState({ pauseBtnFeature: false });
    this.historyTrackingStore.allArray = [];
    this.historyTrackingStore.count = 0;
    this.historyTrackingStore.newPolyLineArray = [];
    this.historyTrackingStore.historyTrackingTableData = [];
    this.historyTrackingStore.polyLineArray = [];
    this.historyTrackingStore.offlineData = [];
    this.historyTrackingStore.offlineDataNewObj = [];
    this.historyTrackingStore.totalCount = null;
    this.historyTrackingStore.total = 0;
    this.historyTrackingStore.pgcount = 1;
    this.historyTrackingStore.offset = 0;
    this.removeMarkerPoints = [];

    this.historyTrackingStore.tripDataArr = [];
    this.historyTrackingStore.offTripDataArr = [];

    await this.setState({
      showBtn: false,
      isPlaying: true,
      selectedRowId: null,
    });
  };

  playFunc = async () => {
    await this.setState({ isPlaying: true });
    // if (this.state.routeOption === 1 || this.state.routeOption === 4) {
    if (this.state.routeOption === 1) {
      await this.straightLineFunc();
    } else if (this.state.routeOption === 5 || this.state.routeOption === 3) {
      await this.overSpeedAndFullPathFunc();
    }
  };

  render() {
    const formItemStyle = { marginBottom: "2px", marginTop: "2px" };

    const { minimized, visible } = this.state;

    const isMarine =
      JSON.parse(base64_decode(Cookies.get("data")))?.industry === "Marine";

    // if (!visible) return null;

    return (
      <div className="historyTracking-container">
        <div className="historyTracking-topsection">
          {!this.props.trackingMapBoolean && (
            <div
              dir={this.context.locale.language === "arabic" ? "ltr" : "ltr"}
              className={
                this.context.locale.language === "arabic"
                  ? "arabic-map-container"
                  : ""
              }
            >
              <MapContainer
                ref={this.mapRef}
                zoom={config.mapZoom}
                // minZoom={5}
                center={config.mapCenter}
                style={{
                  position: "sticky",
                  height: this.state.mapHeight,
                  width: "100wh",
                }}
              >
                {this.state.mapType === "openstreet" ? (
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                ) : (
                  <ReactLeafletGoogleLayer />
                )}

                <AdditionalContentInMap
                  This={this}
                  size="small"
                  showMapOptions={this.state.showMapOptions}
                  mapType={this.state.mapType}
                />
              </MapContainer>
            </div>
          )}
          {(this.props.trackingMapBoolean ||
            this.state.historyTrackingWindow) &&
            visible && (
              <Draggable
                handle=".handle"
                defaultPosition={
                  this.props.trackingMapBoolean
                    ? { x: 340, y: -25 }
                    : { x: 850, y: -25 }
                }
              >
                <Card
                  className="live-routepath-modal"
                  title={
                    <div
                      className="handle"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* <div> Live Route Path</div> */}
                      <div style={{ fontSize: "21px" }}>
                        {this.context.translate("_HISTORY_TRACKING_")}
                      </div>

                      <div>
                        <Button
                          size="small"
                          type="text"
                          onClick={this.handleMinimize}
                        >
                          {minimized ? "🔼" : "🔽"}
                        </Button>

                        {this.props.trackingMapBoolean && (
                          <Button
                            size="small"
                            type="text"
                            onClick={async () => {
                              await this.clearMap();
                              await this.setState({
                                historyTrackingWindow: false,
                              });

                              await this.props?.closeTrackingMapWindow(false);
                            }}
                          >
                            ❌
                          </Button>
                        )}
                      </div>
                    </div>
                  }
                  bodyStyle={{
                    display: minimized ? "none" : "block",
                    transition: "all 0.3s ease",
                  }}
                >
                  <Form
                    onFinish={this.onFinishHistoryTracking}
                    layout="vertical"
                    ref={this.formRef}
                    // style={{ padding: "10px" }}
                    initialValues={{
                      filterBy: 2,
                    }}
                  >
                    <div
                      style={{
                        overflow: "auto",
                        maxHeight: "380px",
                        // padding: "0 12px 0 0",
                        paddingBlock: "0",
                        paddingInlineEnd: "12px",
                        paddingInlineStart: "0",
                        scrollbarWidth: "none",
                      }}
                    >
                      {(this.props.getUserData().isadmin === -1 ||
                        this.props.getUserData().isadmin === 3) && (
                        <>
                          <Row>
                            <Col span={11}>
                              <Form.Item
                                name="companyId"
                                // label="Account"
                                label={this.context.translate(
                                  "_FLEET_DASHBORD_NEWPOI_CUSTOMER_"
                                )}
                                rules={[{ required: true }]}
                              >
                                <CompanyAutocomplete
                                  onChange={async (value) => {
                                    //   await this.handleChangeForDrawingGeofence(value);
                                    await this.setState({
                                      companyId: value.value,
                                    });
                                    await this.historyTrackingStore.getVehicles(
                                      {
                                        companyId: this.state.companyId,
                                      }
                                    );
                                    this.setState({ update: 1 });
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={2} />
                            <Col span={11}>
                              {!isMarine && (
                                <Form.Item
                                  name="filterBy"
                                  // label="Filter By"
                                  label={this.context.translate("_FILTER_BY_")}
                                  rules={[{ required: true }]}
                                >
                                  <Select
                                    // defaultValue={2}
                                    onSelect={async (val) => {
                                      await this.historyTrackingStore.getVehicles(
                                        {
                                          companyId: this.state.companyId,
                                          selectionId: val,
                                        }
                                      );
                                      this.formRef.current.setFieldsValue({
                                        vehicleId: "",
                                      });
                                      await this.setState({ loadList: 1 });
                                    }}
                                  >
                                    {/* <Select.Option value={1}>Vehicle Name</Select.Option>
                                            <Select.Option value={2}>Vehicle No</Select.Option> */}
                                    <Select.Option value={1}>
                                      {this.context.translate(
                                        "_FLEET_VEHICLENAME_"
                                      )}
                                    </Select.Option>
                                    <Select.Option value={2}>
                                      {this.context.translate("_VEHICLE_NO_")}
                                    </Select.Option>
                                  </Select>
                                </Form.Item>
                              )}
                            </Col>
                          </Row>
                        </>
                      )}
                      {this.props.getUserData().isadmin !== -1 &&
                        this.props.getUserData().isadmin !== 3 && (
                          <Row>
                            <Col span={24}>
                              {!isMarine && (
                                <Form.Item
                                  name="filterBy"
                                  // label="Filter By"
                                  label={this.context.translate("_FILTER_BY_")}
                                  rules={[{ required: true }]}
                                >
                                  <Select
                                    // defaultValue={2}
                                    onSelect={async (val) => {
                                      await this.historyTrackingStore.getVehicles(
                                        {
                                          companyId: this.state.companyId,
                                          selectionId: val,
                                        }
                                      );
                                      this.formRef.current.setFieldsValue({
                                        vehicleId: "",
                                      });
                                      await this.setState({ loadList: 1 });
                                    }}
                                  >
                                    {/* <Select.Option value={1}>Vehicle Name</Select.Option>
                                            <Select.Option value={2}>Vehicle No</Select.Option> */}
                                    <Select.Option value={1}>
                                      {this.context.translate(
                                        "_FLEET_VEHICLENAME_"
                                      )}
                                    </Select.Option>
                                    <Select.Option value={2}>
                                      {this.context.translate("_VEHICLE_NO_")}
                                    </Select.Option>
                                  </Select>
                                </Form.Item>
                              )}
                            </Col>
                          </Row>
                        )}

                      <Row>
                        <Col span={11}>
                          <Form.Item
                            label={this.context.translate("_VEHICLES_")}
                            name="vehicleId"
                            style={formItemStyle}
                            rules={[{ required: true }]}
                          >
                            <Select
                              onSelect={(val) => {
                                this.setState({ vehicleId: val });
                              }}
                              showSearch
                              filterOption={(inputValue, option) => {
                                if (option.children) {
                                  return (
                                    option.children
                                      .toLowerCase()
                                      .indexOf(inputValue.toLowerCase()) >= 0
                                  );
                                }
                              }}
                            >
                              {this.historyTrackingStore?.vehiclesArray?.map(
                                (val) => {
                                  return (
                                    <Option
                                      vehicleObj={val}
                                      value={val.vehicleId}
                                      key={val.vehicleId}
                                    >
                                      {isMarine
                                        ? `${val.vehicleNo}/${val.vehicleName}`
                                        : val.vehicleNo}
                                    </Option>
                                  );
                                }
                              )}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={2}></Col>
                        <Col span={11}>
                          <Form.Item
                            // label="Select Route Options"
                            label={this.context.translate(
                              "_SELECT_ROUT_OPTION_"
                            )}
                            name="SelRoutOption"
                            style={formItemStyle}
                            rules={[
                              {
                                required: true,
                                message: this.context.translate(
                                  "_SELECT_ROUT_OPTION_"
                                ),
                              },
                            ]}
                          >
                            <Select
                              onSelect={(val) =>
                                this.setState({ routeOption: val })
                              }
                            >
                              <Select.Option value={1}>
                                Straight Line
                              </Select.Option>
                              <Select.Option value={3}>Full Path</Select.Option>
                              <Select.Option value={4}>Trip</Select.Option>
                              <Select.Option value={5}>Overspeed</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Form.Item
                        label={this.context.translate("_SELECT_DATE_")}
                        name=""
                        // style={formItemStyle}
                        // rules={[{ required: true }]}
                      >
                        <RangePicker
                          placeholder={[
                            this.context.translate("_FROM_DATE_TIME_"),
                            this.context.translate("_TO_DATETIME_"),
                          ]}
                          format="DD-MM-YYYY hh:mmA"
                          // style={{ width: 400 }}
                          onChange={(val) => {
                            this.onDateTimeChange(val);
                          }}
                          disabledDate={(current) => {
                            return current && current > dayjs();
                          }}
                          showTime={{
                            format: "h:mmA",
                            defaultValue: [dayjs().startOf("day"), dayjs()],
                          }}
                          defaultValue={[dayjs().startOf("day"), dayjs()]}
                        />
                      </Form.Item>
                      {/* <Row>
                                          <Col span={11}>
                                            <Form.Item
                                              label="From Date"
                                              name="fromD"
                                              style={formItemStyle}
                                            >
                                              <DatePicker
                                                allowClear={false}
                                                format={"MM-DD-YYYY"}
                                                defaultValue={dayjs()}
                                                onChange={async (val) => {
                                                  // await this.setState({
                                                  //     fromDate: val?.format("YYYY-MM-DD"),
                                                  //   })
                                                  await this.formRef.current.setFieldsValue({
                                                    fromD: val,
                                                  });
                                                  await this.formRef.current.setFieldsValue({
                                                    toD: val,
                                                  });
                                                }}
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col span={2}></Col>
                                          <Col span={11}>
                                            <Form.Item
                                              label="To Date"
                                              name="toD"
                                              style={formItemStyle}
                                            >
                                              <DatePicker
                                                allowClear={false}
                                                format={"MM-DD-YYYY"}
                                                defaultValue={dayjs()}
                                                onChange={(val) =>
                                                  //   this.setState({
                                                  //     toDate: val?.format("YYYY-MM-DD"),
                                                  //   })
                                                  this.formRef.current.setFieldsValue({ toD: val })
                                                }
                                              />
                                            </Form.Item>
                                          </Col>
                                        </Row> */}
                      {/* 
                                        <Row>
                                          <Col span={11}>
                                            <Form.Item
                                              label="From Time"
                                              name="fromTime"
                                              style={formItemStyle}
                                              initialValue={"00:00:00"}
                                            >
                                              <Select
                                                onChange={this.setFromTime}
                                                onSelect={(val) => this.setState({ fromTime: val })}
                                                // value={this.state.fromTime}
                      
                                                allowClear={true}
                                              >
                                                {this.timeOptions()}
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col span={2}></Col>
                                          <Col span={11}>
                                            <Form.Item
                                              label="To Time"
                                              name="toTime"
                                              style={formItemStyle}
                                              initialValue={dayjs().format("hh:mm A")}
                                            >
                                              <Select
                                                onSelect={(val) => this.setState({ toTime: val })}
                                                onChange={(e) => console.log(e)}
                                                // value={this.state.fromTime}
                                                allowClear={true}
                                              >
                                                {this.timeOptions()}
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                        </Row> */}

                      <Row
                        style={{
                          display:
                            this.state.routeOption === 5 ||
                            this.state.routeOption === 4
                              ? "none"
                              : "",
                          marginBottom: "10px",
                        }}
                      >
                        <Col span={11}>
                          <Form.Item
                            // label="Select Trip Event"
                            label={this.context.translate(
                              "_SELECT_TRIP_EVENT_"
                            )}
                            name="TripEventdata"
                            style={formItemStyle}
                          >
                            <Select
                              onSelect={(val) =>
                                this.setState({ tripEventOption: val })
                              }
                            >
                              <Select.Option value={1}>All</Select.Option>
                              <Select.Option value={2}>Travel</Select.Option>
                              <Select.Option value={3}>Stopped</Select.Option>
                              <Select.Option value={4}>Idle</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={2} />

                        <Col
                          span={11}
                          style={{
                            display:
                              this.state.routeOption === 5 ||
                              this.state.routeOption === 4
                                ? "none"
                                : "",
                          }}
                        >
                          {this.state.selectedCompanyId == 1903 ||
                            (!(
                              this.state.companyId == 1903 &&
                              config.project === "securetrack" &&
                              this.state.routeOption === 3
                            ) && (
                              <Form.Item
                                // label="Select Speed"
                                label={this.context.translate("_SELECT_SPEED_")}
                                name="speed"
                                style={formItemStyle}
                              >
                                <Select
                                  onSelect={(val) =>
                                    this.setState({ speed: val })
                                  }
                                >
                                  <Select.Option value={1}>Fast</Select.Option>
                                  <Select.Option value={2}>
                                    Medium
                                  </Select.Option>
                                  <Select.Option value={3}>
                                    Slower
                                  </Select.Option>
                                </Select>
                              </Form.Item>
                            ))}
                        </Col>
                      </Row>

                      <div
                        style={{
                          display: this.state.routeOption === 4 ? "" : "none",
                        }}
                      >
                        <Form.Item
                          // label="Event Name"
                          label={this.context.translate("_EVENT_NAME_")}
                          name="speed"
                          style={formItemStyle}
                        >
                          <Select defaultValue={1}>
                            <Select.Option value={1}>No Event</Select.Option>
                            <Select.Option value={2}>
                              Harsh Acceleration
                            </Select.Option>
                            <Select.Option value={3}>
                              Harsh Deacceleration
                            </Select.Option>
                            <Select.Option value={4}>
                              Load Sensor Disconnect Alarm
                            </Select.Option>
                            <Select.Option value={5}>
                              Power Cut Alarm
                            </Select.Option>
                            <Select.Option value={6}>
                              High Impact(Accident)
                            </Select.Option>
                            <Select.Option value={7}>
                              Low Impact(Incident)
                            </Select.Option>
                            <Select.Option value={8}>
                              GSM Jamming Alarm
                            </Select.Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        paddingTop: "12px",
                        borderTop: "1px solid gray",
                        width: "100%",
                        alignItems: "center",
                        // paddingBottom: "12px",
                      }}
                    >
                      {this.state.showBtn && (
                        <Button
                          disabled={this.state.pauseBtnFeature}
                          className="formCancelButton"
                          onClick={() => {
                            this.setState({
                              isPlaying: false,
                              pauseBtnFeature: true,
                            });
                          }}
                        >
                          Pause
                        </Button>
                      )}
                      {
                        <div
                          style={{
                            display: this.state.showBtn === false ? "" : "none",
                          }}
                        >
                          <Button
                            htmlType="submit"
                            className="formCancelButton"
                            type="primary"
                          >
                            {/* Show */}
                            {this.context.translate("_FLEET_SHOW_BTN_")}
                          </Button>
                        </div>
                      }
                      {this.state.showBtn && (
                        <Button
                          type="primary"
                          className="formCancelButton"
                          onClick={() => {
                            this.playFunc();
                            this.setState({ pauseBtnFeature: false });
                          }}
                          disabled={!this.state.pauseBtnFeature}
                        >
                          Play
                        </Button>
                      )}

                      <Button
                        onClick={this.clearMap}
                        className="formCancelButton"
                      >
                        {/* Clear */}
                        {this.context.translate("_FLEET_CLEAR_BTN_")}
                      </Button>
                      {/* <Button type="primary" className="formSaveButton">
                                        Close
                                      </Button> */}
                    </div>
                  </Form>
                </Card>
              </Draggable>
            )}
        </div>

        {!this.props.trackingMapBoolean && this.state.showGrid && (
          <div className="historyTracking-bottomsection">
            <Table
              rowClassName={(record) => {
                return this.state.selectedRowId === record.Id
                  ? "selected-row"
                  : "";
              }}
              rowKey={"Id"}
              onRow={(record, rowIndex) => {
                return {
                  onClick: async (event) => {
                    // this.setState({ selectedRowId: record.fromdate });
                    this.setState((prevState) => ({
                      selectedRowId:
                        prevState.selectedRowId === record.Id
                          ? null // remove highlight if same row clicked
                          : record.Id,
                    }));
                    if (this.state.routeOption != 4) {
                      this.mapRef.current.setView(
                        [record.latitude, record.longitude],
                        19
                      );
                    }
                  },
                };
              }}
              pagination={false}
              scroll={{ y: 160 }}
              bordered
              columns={
                this.state.routeOption == 4 ? this.tripColumns : this.columns
              }
              dataSource={
                this.state.routeOption == 4
                  ? this.historyTrackingStore.tripDataArr
                  : (this.historyTrackingStore.offlineDataNewObj.length > 0 && [
                      ...this.historyTrackingStore.offlineDataNewObj,
                    ]) ||
                    this.historyTrackingStore.historyTrackingTableData
              }
              // columns={this.tripColumns}
              // dataSource={this.historyTrackingStore.tripDataArr}
              // columns={this.columns}
              // dataSource={
              //   (this.historyTrackingStore.offlineDataNewObj.length > 0 && [
              //     ...this.historyTrackingStore.offlineDataNewObj,
              //   ]) ||
              //   this.historyTrackingStore.historyTrackingTableData
              // }
            />
          </div>
        )}
      </div>
    );
  }
}

HistoryTracking.contextType = StoreContext;
export default observer(withRouter(HistoryTracking));
